import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { generateMyApiKey } from "../../../redux/actions/apiKeys.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import KeyActionModal from "../../../components/common/KeyActionModal";

const GenerateMyKeyModal: React.FC<ModalProps> = ({ open, setOpen, object }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { error, loading } = useSelector((state: RootState) => state.myApiKeys);

  return (
    <KeyActionModal
      open={open}
      setOpen={setOpen}
      title={`Generate API key for ${object?.name ?? object?.spaGuid}?`}
      body="A new bearer key will be issued for this spa."
      actionLabel="Generate"
      loadingLabel="Generating..."
      loading={loading}
      error={error}
      onConfirm={async () => {
        const action = await dispatch(generateMyApiKey({ spaGuid: object?.spaGuid }));
        return generateMyApiKey.fulfilled.match(action) ? action.payload?.apiKey ?? null : null;
      }}
    />
  );
};

export default GenerateMyKeyModal;
